import { MutationTree } from "vuex";

import { AnalyseState } from "./types";

export const mutations: MutationTree<AnalyseState> = {};
